module.exports = __webpack_public_path__ + "static/paris-019-08d57eb4bf841e52db868d4b342b9bde.jpg";